// extracted by mini-css-extract-plugin
export default {"RegistryBackToTop":"RegistryBackToTop-styles__RegistryBackToTop__g7kKN"};